<!-- The 'Available Channels' popup for choosing which channels to allow a global instance on -->
<template>
   <div id="available_channels_popup">
      <span class="dialog-triangle"></span>
      <div class="header">CHANNELS that play this INSTANCE</div>

      <div class="checks-container">

         <global-channel-selections
            :initialSelected="initialSelected"
            :selections="channelSelections"
            @lastCheck="$emit('lastCheck')">
         </global-channel-selections>
      </div>

      <div class="reminder">
         <div class="bold">REMINDER</div>
         <div class="reminder-text">
            Changes to this Instance affect all selected channels
         </div>
      </div>
   </div>
</template>

<script>
import GlobalChannelSelections from './GlobalChannelSelections';

export default {

   props: {
      initialSelected: Array,
      channelSelections: Array
   },

   components: {
      GlobalChannelSelections
   }
}
</script>

<style lang="scss" scoped>
#available_channels_popup {
   position: absolute;
   background: #fff;
   right: 26px;
   top: 40px;
   padding: 15px 20px;
   border-radius: 3px;
   z-index: 200000;
   border: 1px solid #ececec;

   .dialog-triangle {
      border-color: transparent transparent #ececec transparent; 
   }

   .header {
      font-size: 14px;
   }

   .checks-container {
      margin-top: 7px;
      font-weight: normal;
      color: $bard-gray;
      margin-left: 10px;
   }

   .check-container {
      display: flex;
      align-items: center;
   }

   .reminder {
      font-weight: normal;
      color: $error-red;

      .bold {
         font-weight: bold;
         text-transform: uppercase;
      }

      .reminder-text {
         font-size: 10px;
      }
   }
}
</style>
